__turbopack_context__.v({
  "encryptButton": "styles-module-scss-module__-nPA1q__encryptButton",
});
